export function isOngoingCall(call) {
  return !!(call.startedAt && !call.endedAt)
}

export function isMissedCall(call) {
  return !!(call.endedAt && !call.answeredAt)
}

export function isOutboundCall(call) {
  return call.direction === 'outbound'
}

export function isInboundCall(call) {
  return call.direction === 'inbound'
}

export function isUntaggedCall(call) {
  if (call.direction === 'inbound') {
    return !call.leadTag && !isMissedCall(call);
  }
  if (call.direction === 'outbound') {
    return !call.leadTag;
  }
}

export function isMissedInboundCall(call) {
  return isInboundCall(call) && isMissedCall(call);
}

export function isMissedOutboundCall(call) {
  return isOutboundCall(call) && isMissedCall(call);
}
